<template>
  <b-container class="bv-example-row">
    <b-button class="mb-3" variant="success" @click="ShowDetail"
      >ایجاد لینک هدف</b-button
    >
    <b-modal id="transaction-details" hide-footer>
      <template v-slot:modal-title>ایجاد لینک هدف شخصی</template>
      <b-row align-v="center">
        <b-col cols="3" sm="3" md="3">
          <b-form-group>
            <div class="form-control border border-0">عنوان:</div>
          </b-form-group>
        </b-col>
        <b-col cols="9" sm="9" md="9">
          <b-form-group>
            <b-form-input
              v-model="goallink.title"
              type="text"
              placeholder="عنوان لینک پرداخت را وارد کنید"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="3" sm="3" md="3">
          <b-form-group>
            <div class="form-control border border-0">مبلغ (ریال):</div>
          </b-form-group>
        </b-col>
        <b-col cols="9" sm="9" md="9">
          <b-form-group>
            <numberSeprator
              v-model="goallink.amount"
              placeholder="مبلغ هدف خود را تعیین کنید"
            ></numberSeprator>
          </b-form-group>
        </b-col>
        <b-col cols="3" sm="3" md="3">
          <b-form-group>
            <div class="form-control border border-0">توضیحات:</div>
          </b-form-group>
        </b-col>
        <b-col cols="9" sm="9" md="9">
          <b-form-group >
            <b-form-textarea
              id="textarea"
              v-model="goallink.description"
              placeholder="توضیحات لینک پرداخت را وارد کنید"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group class="" label=" ">
            <b-button
              :class="loading ? 'spinner spinner-light spinner-right' : ''"
              block
              variant="success"
              @click="createLink"
              >ایجاد لینک هدف</b-button
            >
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group class="" label=" ">
            <b-button block @click="hideAddCardModal">بستن</b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <list-table
      :url="url"
      title="لیست لینک های پرداخت هدفدار"
      :fields="fields"
      :btns="btns"
      :excelroute="'excelroute'"
      :params="params"
    ></list-table>
  </b-container>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { CREATE_GOALLINK } from "@/core/services/store/goalLink.module";
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";
import numberSeprator from "../../components/numberSeprator";

export default {
  name: "goallinks",
  data() {
    return {
      goallink: {
        goallink:null,
        title:null,
        description:null,
      },
      loading: false,
      canCopy: false,
      btns: [
        {
          icon: "list",
          title: 'لیست تراکنش ها',
          handler: (t) => {
            this.$router.push("goallinks/" + t.id);
          },
        },
        {
          icon: "file-earmark",
           title: 'کپی کردن',
          handler: (t) => {
            navigator.clipboard.writeText("http://she.pa/@goal-link/" + t.id);
            this.$makeToast('success','کپی لینک',`http://she.pa/@goal-link/${t.id} کپی شد`,5000)
          },
        },
      ],
      url: "goal-link",
     params: [
        {
      label: "از تاریخ",
      field: "dateFrom",
      type: "date-picker",
      },
      {
      label: "تا تاریخ",
      field: "dateTo",
      type: "date-picker",
      },
        {
          label: "عنوان لینک:",
          field: "title",
          type: "text",
        },
        {
          label: "مبلغ (ریال):",
          field: "amount",
          type: "number",
        },
      ],
      fields: [
        {
          key: "id",
          label: "کد لینک",
        },
        // {
        // key: "shaba_number",
        // label: "شماره شبا"
        // },
        // {
        // key: "nickname",
        // label: "ردیف"
        // },
        {
          key: "title",
          label: "عنوان لینک",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
         
        },
        {
          key: "description",
          label: "توضیحات",
        },
        {
          key: "sumCost",
          label: "مبلغ جمع آوری شده(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },

        {
          key: "btns",
          label: "عملیات",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    numberSeprator,
  },
  created() {
    this.canCopy = !!navigator.clipboard;
  },
  methods: {
    createLink() {
      this.loading = true;
      this.$store.dispatch(CREATE_GOALLINK, this.goallink).then((response) => {
        this.loading = false;
        if (response.success) {
          this.goallink = {};
          this.hideAddCardModal();
          this.url = this.url + "?t=" + new Date().getTime();
          this.$makeToast('success','ثبت موفق',"اطلاعات با موفقیت ثبت گردید.",5000)
        } else {
          response.error.amount
            ? this.$makeToast('error','خطا',response.error.amount[0],5000) : "";
          response.error.description
            ? this.$makeToast('error','خطا',response.error.description[0],5000) : "";
          response.error.title
            ? this.$makeToast('error','خطا',response.error.title[0],5000) : "";
        }
      });
    },
    hideAddCardModal: function () {
      this.goallink={};
      this.$bvModal.hide("transaction-details");
    },
    ShowDetail() {
      this.$bvModal.show("transaction-details");
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لینک های پرداخت هدفدار" }]);
  },
};
</script>

